import type { Topic } from "@/types/content";

export const topics: Topic[] = [
  {
    id: "topic-1",
    slug: "wellness-relax",
    title: "放鬆療癒",
    description: "按摩、SPA、越式洗髮、岩盤浴與腳底按摩，幫你找回身心平衡的各種放鬆方式。也涵蓋暖罐療法等傳統熱療舒壓體驗。",
    coverImage: "https://readdy.ai/api/search-image?query=Luxurious%20spa%20treatment%20room%20with%20warm%20ambient%20lighting%20candles%20essential%20oils%20and%20flower%20petals%20zen%20minimalist%20wellness%20interior%20simple%20neutral%20background%20photography%20soft%20and%20serene%20atmosphere&width=1200&height=630&seq=501&orientation=landscape",
    articleIds: ["post-1", "post-2", "post-4", "post-15", "post-22", "post-23"],
    storeIds: ["svc-1", "svc-12"],
  },
  {
    id: "topic-2",
    slug: "beauty-care",
    title: "美容保養",
    description: "臉部護理、做臉清粉刺、頭皮護理，專注於肌膚與頭皮的健康管理，讓你由內而外散發光彩。",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20facial%20treatment%20room%20with%20professional%20skincare%20equipment%20clean%20white%20interior%20soft%20lighting%20beauty%20clinic%20atmosphere%20simple%20background%20photography%20elegant%20and%20calming%20environment&width=1200&height=630&seq=502&orientation=landscape",
    articleIds: ["post-5", "post-13", "post-16", "post-21"],
    storeIds: ["svc-7", "svc-11"],
  },
  {
    id: "topic-3",
    slug: "appearance",
    title: "外貌美化",
    description: "美髮、美甲、美睫、霧眉、除毛，從頭到腳打造精緻外在，展現最自信的自己。",
    coverImage: "https://readdy.ai/api/search-image?query=Elegant%20beauty%20salon%20interior%20with%20modern%20styling%20stations%20mirrors%20and%20warm%20lighting%20professional%20hair%20and%20nail%20salon%20atmosphere%20simple%20clean%20background%20photography%20chic%20and%20sophisticated%20design&width=1200&height=630&seq=503&orientation=landscape",
    articleIds: ["post-6", "post-7", "post-8", "post-9", "post-10"],
    storeIds: ["svc-2", "svc-3", "svc-4", "svc-5"],
  },
  {
    id: "topic-4",
    slug: "mind-body-spirit",
    title: "身心靈",
    description: "塔羅、命理、星盤、馬雅圖騰，在忙碌生活中找到內在指引，探索靈性成長的無限可能。",
    coverImage: "https://readdy.ai/api/search-image?query=Mystical%20tarot%20reading%20scene%20with%20candles%20crystals%20and%20incense%20warm%20ambient%20lighting%20bohemian%20spiritual%20atmosphere%20simple%20background%20photography%20intimate%20and%20contemplative%20mood&width=1200&height=630&seq=504&orientation=landscape",
    articleIds: ["post-11", "post-12", "post-18", "post-20"],
    storeIds: ["svc-8"],
  },
  {
    id: "topic-5",
    slug: "health-wellness",
    title: "健康養生",
    description: "瑜珈、健康調理、經絡養生，建立身體的長期健康基礎，讓生活更有活力與品質。",
    coverImage: "https://readdy.ai/api/search-image?query=Peaceful%20yoga%20studio%20with%20wooden%20floors%20natural%20light%20and%20green%20plants%20meditation%20space%20wellness%20atmosphere%20simple%20clean%20background%20photography%20calming%20and%20rejuvenating%20environment&width=1200&height=630&seq=505&orientation=landscape",
    articleIds: ["post-16", "post-17", "post-19"],
    storeIds: [],
  },
  {
    id: "topic-6",
    slug: "image-photo",
    title: "形象與攝影",
    description: "形象管理、個人品牌攝影、商業形象照，用專業鏡頭捕捉你最好的模樣，提升職場與社交自信。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_9ff72d8ea71395bc600b4bb0c610502e_a43f98fc.jpg",
    articleIds: ["post-19", "post-28"],
    storeIds: ["svc-10", "svc-17"],
  },
  {
    id: "topic-7",
    slug: "makeup-styling",
    title: "彩妝造型",
    description: "新娘彩妝、日常彩妝課程、整體造型服務，從專業彩妝師到造型師一手包辦，讓你在重要時刻散發最耀眼的光芒。",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20makeup%20artist%20studio%20with%20cosmetics%20brushes%20palette%20and%20mirror%20warm%20soft%20lighting%20beauty%20makeup%20session%20elegant%20clean%20background%20photography&width=1200&height=630&seq=507&orientation=landscape",
    articleIds: ["post-24"],
    storeIds: ["svc-13"],
  },
  {
    id: "topic-8",
    slug: "warm-cupping",
    title: "暖罐",
    description: "結合傳統中醫拔罐與熱療原理的暖罐療法，透過溫熱刺激促進氣血循環、舒緩深層肌肉緊繃，是近年台灣美業最受關注的養生新趨勢。",
    coverImage: "https://readdy.ai/api/search-image?query=Traditional%20cupping%20therapy%20session%20with%20warm%20glass%20cups%20on%20back%20chinese%20medicine%20hot%20cupping%20treatment%20spa%20wellness%20simple%20clean%20background%20photography%20warm%20amber%20lighting&width=1200&height=630&seq=508&orientation=landscape",
    articleIds: ["post-25"],
    storeIds: ["svc-14"],
  },
  {
    id: "topic-9",
    slug: "color-analysis",
    title: "色彩鑑定",
    description: "透過專業色彩分析找出最適合你的色調系統，從穿搭到彩妝都能精準配色，讓整體形象煥然一新。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_a3f6c6e7a85481aac1d61071ec5b3f23_fd89b747.jpg",
    articleIds: ["post-26"],
    storeIds: ["svc-15"],
  },
  {
    id: "topic-10",
    slug: "fashion-styling",
    title: "穿搭",
    description: "個人穿搭風格定位、膠囊衣櫥規劃、場合穿搭建議，幫你建立與內在一致的外在形象，穿出自信與品味。",
    coverImage: "https://public.readdy.ai/ai/img_res/edited_0776fd8f7b4be2d4f281335df52db9ad_8716e13e.jpg",
    articleIds: ["post-27"],
    storeIds: ["svc-16"],
  },
  {
    id: "topic-11",
    slug: "mind-body-relief",
    title: "光療舒壓",
    description: "冥想、頌缽、聲音療癒、呼吸工作坊，透過各種非侵入性的身心技法，釋放深層壓力、恢復內在平靜。適合高壓族群與追求心靈平衡的現代人。",
    coverImage: "https://readdy.ai/api/search-image?query=Serene%20meditation%20and%20sound%20healing%20studio%20with%20singing%20bowls%20candles%20soft%20warm%20lighting%20peaceful%20atmosphere%20mindfulness%20space%20simple%20clean%20background%20photography%20calming%20environment%20zen%20minimal&width=1200&height=630&seq=511&orientation=landscape",
    articleIds: ["post-29"],
    storeIds: ["svc-18"],
  },
];